import { Link, usePage } from "@inertiajs/react";
import {
  BookOpen,
  Building,
  CheckCircle2,
  Component,
  Contact,
  DollarSign,
  FileText,
  FolderTree,
  LayoutGrid,
  Package,
  Receipt,
  Store,
  Truck,
  Users,
} from "lucide-react";

import { NavFooter } from "@/components/nav-footer";
import { NavMain } from "@/components/nav-main";
import { NavUser } from "@/components/nav-user";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";
import { useAnnouncementStatus } from "@/hooks/use-announcement-status";
import {
  categoriesPath,
  companiesPath,
  dashboardPath,
  deliveryNotesPath,
  invoicesPath,
  pricesPath,
  productsPath,
  purchaseRequestsPath,
  sectorsPath,
  suppliersPath,
  userManualPath,
  usersPath,
} from "@/routes";
import type { NavItem, SharedData } from "@/types";

import AppLogo from "./app-logo";

const mainNavItems: NavItem[] = [
  {
    title: "Dashboard",
    href: dashboardPath(),
    icon: LayoutGrid,
  },
  {
    title: "Solicitudes Compras",
    href: purchaseRequestsPath(),
    icon: FileText,
  },
  {
    title: "Remitos",
    href: deliveryNotesPath(),
    icon: Truck,
  },
  {
    title: "Facturas",
    href: invoicesPath(),
    icon: Receipt,
  },
  {
    title: "Solicitudes por aprobar",
    href: "/approvals",
    icon: CheckCircle2,
  },
  {
    title: "Productos",
    href: productsPath(),
    icon: Package,
  },
  {
    title: "Histórico de Precios",
    href: pricesPath(),
    icon: DollarSign,
  },
  {
    title: "Sectores/Obras",
    href: sectorsPath(),
    icon: Building,
  },
  {
    title: "Compañías",
    href: companiesPath(),
    icon: Component,
  },
  {
    title: "Categorías",
    href: categoriesPath(),
    icon: FolderTree,
  },
  {
    title: "Proveedores",
    href: suppliersPath(),
    icon: Store,
  },
  {
    title: "Usuarios",
    href: usersPath(),
    icon: Users,
  },
];

const footerNavItems: NavItem[] = [
  // Example add items to navbar
  {
    title: "Soporte",
    href: "https://tally.so/r/nre9Ll",
    icon: Contact,
  },
  {
    title: "Manual de uso",
    href: userManualPath(),
    icon: BookOpen,
  },
];

export function AppSidebar() {
  const { ui } = usePage<SharedData>().props;
  const hasNewAnnouncements = useAnnouncementStatus(ui?.announcements_version);

  // Crear items de navegación con el indicador para Dashboard
  const navItemsWithIndicator = mainNavItems.map((item) => {
    if (item.title === "Dashboard") {
      return {
        ...item,
        hasIndicator: hasNewAnnouncements,
      };
    }
    return item;
  });

  return (
    <Sidebar collapsible="icon" variant="inset">
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton size="lg" asChild>
              <Link href={dashboardPath()} prefetch>
                <AppLogo />
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>

      <SidebarContent>
        <NavMain items={navItemsWithIndicator} />
      </SidebarContent>

      <SidebarFooter>
        <NavFooter items={footerNavItems} className="mt-auto" />
        <NavUser />
      </SidebarFooter>
    </Sidebar>
  );
}
